// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tips_footnote__xNV-K {
    display: inline;
    vertical-align: super;
    font-size: 10px;
    padding-bottom: 10px;
}

.tips_graphTip__qegLd {
    min-height: 26px;
    font-weight: 300;
    display: flex;
    align-items: center;
    padding-left: 32px;
    position: relative;
}

.tips_graphTip__qegLd:not(:last-child) {
    margin-bottom: 20px;
}

.tips_graphTip__qegLd:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    box-sizing: border-box;
}

.tips_initial__sEK1U:before {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #1650b4;
    left: 2px;
}

.tips_nav__Jdlas:before {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #1650b4;
    left: 2px;
}

.tips_taxed__HAQgi:before {
    width: 12px;
    height: 12px;
    border: 1px solid #000;
    left: 4px;
}

.tips_days__pWCuZ:before {
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background: #ffdede;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .tips_graphTip__qegLd:not(:last-child) {
        margin-bottom: 10px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LegalStructures/components/Tips/tips.module.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ,OAAO;IACP,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["@value screen-md-max from '../../../../breakpoints.css';\n\n.footnote {\n    display: inline;\n    vertical-align: super;\n    font-size: 10px;\n    padding-bottom: 10px;\n}\n\n.graphTip {\n    min-height: 26px;\n    font-weight: 300;\n    display: flex;\n    align-items: center;\n    padding-left: 32px;\n    position: relative;\n}\n\n.graphTip:not(:last-child) {\n    margin-bottom: 20px;\n}\n\n.graphTip:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    left: 0;\n    box-sizing: border-box;\n}\n\n.initial:before {\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    background: #1650b4;\n    left: 2px;\n}\n\n.nav:before {\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    border: 1px solid #1650b4;\n    left: 2px;\n}\n\n.taxed:before {\n    width: 12px;\n    height: 12px;\n    border: 1px solid #000;\n    left: 4px;\n}\n\n.days:before {\n    width: 19px;\n    height: 19px;\n    border-radius: 50%;\n    background: #ffdede;\n}\n\n@media screen-md-max {\n    .graphTip:not(:last-child) {\n        margin-bottom: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"footnote": `tips_footnote__xNV-K`,
	"graphTip": `tips_graphTip__qegLd`,
	"initial": `tips_initial__sEK1U`,
	"nav": `tips_nav__Jdlas`,
	"taxed": `tips_taxed__HAQgi`,
	"days": `tips_days__pWCuZ`
};
export default ___CSS_LOADER_EXPORT___;
